import { useEffect, useRef, useState } from 'react';
import { getUserMetadataAPI } from './utils';
import { getUserName } from './helpers';

function useDashboard() {
  const [userMetadataData, setUserMetadataData] = useState({});
  const [userMetadataDataLoaded, setUserMetadataDataLoaded] = useState(false);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserMetadataAPI(getUserName(), userMetadataCallback);
      hasFetchedData.current = true;
    }
  }, []);

  const userMetadataCallback = (data) => {
    setUserMetadataData(data.body);
    setUserMetadataDataLoaded(true);
  };

  return {
    userMetadataData,
    userMetadataDataLoaded,
  };
}

export { useDashboard };
